export enum EAllSettledStatus {
	FULFILLED = 'fulfilled',
	REJECTED = 'rejected',
}

export interface IAllSettledResponse<T> {
	fulfilled: T[];
	rejected: T[];
}
